
<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img"/>
    </ion-button>
  </ion-menu-toggle>

  <div class="top-section">
    <p class="filters-header">
       {{userService.business ? userService.business.name : ''}} | Shortcut
    </p>
    <h2 class="filters-text">
      List of Pro accounts
    </h2>
  </div>

  <div class="SCWEB-address-container" (click)="openSccToThisPage()">
    <p>View more information</p>
    <ion-icon name="arrow-redo-circle-outline"></ion-icon>
  </div>

  <div class="pro-section">

    <div *ngFor="let screenItem of screenItems">

      <div class="card-group-w-header" *ngIf="screenItem.type == 'barber-group' || screenItem.type == 'day-segment-group'">

        <h3 class="title"> {{screenItem.title}} </h3>
        <p class="subtitle"> {{screenItem.subtitle}} </p>

        <div class="barber-cards">
          <ion-card class="barber-card" *ngFor="let avail of screenItem.showingAvails" (click)="goToBarber(avail.barber.link, 'Main Screen', null, avail.canBook)">

            <ion-card-content class="barber-card-content">

              <div class="col-barber-img">
                <img [src]="avail.barber.imgURL || placeholderURL" class="barber-img"/>
              </div>

              <div class="col-barber-info">
                <h4> {{avail.barber.name}} </h4>

                <div class="barber-stars">
                  <ion-icon name="star" class="SC-star-icon" [ngClass]="avail.barber.numRatings <= 3 ? 'stars-less-opaque' : ''" *ngFor="let _ of toRange(roundedRating(avail.barber.rating))"></ion-icon>

                  <span class="rating-label" *ngIf="avail.barber.numRatings > 5">({{avail.barber.numRatings}})</span>
                  <span class="rating-label gold" *ngIf="avail.barber.numRatings <= 5">(Newly added)</span>
                </div>
              </div>

              <div class="pin-text">
                <div class="works-from-home-container" *ngIf="avail.barber.acceptOnlyCustomAddress">
                    <ion-icon name="home"></ion-icon>
                    <span>Works at home</span>
                </div>

                <span>
                  {{avail.barber.cityState}}
                </span>
                <ion-icon name="navigate-circle-outline"></ion-icon>
              </div>

              <div *ngIf="screenItem.type == 'barber-group'" class="card-bottom">
                <div class="recent-curated-review" *ngIf="avail.barber.featuredReview">
                  <img src="assets/img/quote.png" class="quote-img"/>
                  <p class="recent-quote">{{avail.barber.featuredReview}} <span class="quoter">– {{avail.barber.featuredReviewFirstName}}</span></p>
                </div>
                <div *ngIf="!avail.barber.featuredReview">
                  <ion-button fill="outline" class="action-button">View {{avail.barber.firstName}}'s profile</ion-button>
                </div>
              </div>

              <div *ngIf="screenItem.type == 'day-segment-group'" class="card-bottom">
                <div class="timeslots" *ngIf="avail.availableTimes && avail.availableTimes.length">
                  <ion-card *ngFor="let timeString of avail.availableTimes" class="time-card" (click)="goToBarber(avail.barber.link, 'Main Screen', stringToDate(timeString), avail.canBook)">
                    <ion-card-content>
                      <p>{{ getAdjustedDisplayTime(stringToDate(timeString), avail.timezoneOffset) }}</p>
                    </ion-card-content>
                  </ion-card>
                </div>
                <div *ngIf="!avail.availableTimes || !avail.availableTimes.length">
                  <ion-button fill="outline" class="action-button">View {{avail.barber.firstName}}'s profile</ion-button>
                </div>
              </div>

            </ion-card-content>
          </ion-card>

          <p class="show-more-button" *ngIf="screenItem.hasShowMore" (click)="showMoreAvails(screenItem)">
            View more ({{screenItem.avails.length - screenItem.showingAvails.length}})
            <ion-icon name="arrow-down" class="dropdown-arrow"></ion-icon>
          </p>
        </div>

      </div>
    </div>

  </div>

  <div class="SC-empty-state-div" [hidden]="screenItems">
    <ion-spinner class="SC-empty-state-spinner" [hidden]="errorString"></ion-spinner>
    <p  *ngIf="userService.user" class="SC-empty-state-text" [hidden]="errorString">Finding your Pros...</p>
    <p class="SC-empty-state-text" [hidden]="!errorString">{{errorString}}</p>
  </div>

  <div class="SC-empty-state-div" [hidden]="!screenItems || screenItems.length">
    <ion-icon name="person-add-outline" class="SC-empty-state-icon"></ion-icon>
    <p class="SC-empty-state-text">No Pros registered yet.</p>
    <p class="SC-empty-state-action SC-clickable" (click)="openRegisterPro()">REGISTER A NEW PRO</p>
  </div>

</ion-content>
